import styled from "styled-components";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import { Outlet, useLocation } from "react-router-dom";
import LoaderComponent from "./components/generic/LoaderComponent";
import { lazy, Suspense, useEffect, useRef, useState } from "react";

import ScrollToTop from "./helpers/ScrollToTop";
import SitemMap from "./components/SiteMap/SitemMap";
import { Helmet, HelmetProvider } from "react-helmet-async";
const LazyCookieConsent = lazy(() => import("./helpers/CookieConsent"));

function App() {
  const [loading, setLoading] = useState(false);
  const [isBackgropVisible, setIsBackgropVisible] = useState(false);
  const [isPageScrolled, setIsPageScrolled] = useState(false);
  const [showCookieConsent, setShowCookieConsent] = useState(false);
  const scrollRef = useRef(null);

  const routeThemeColors = {
    "/": "rgba(25, 34, 74, 1)",
    "/messaging": "rgba(66, 0, 0, 1)",
    "/engagement": "rgba(8, 36, 41, 1)",
    "/analyse": "rgba(39, 16, 60, 1)",
    "/product": "rgba(8, 36, 41, 1)",
    "/marketing": "rgba(76, 31, 61, 1)",
    "/pricing": "#ffff",
    "/privacy": "#ffff",
    "/security": "#ffff",
    "/sla": "#ffff",
    "/blog": "#ffff",
    "/create": "#ffff",


  };
  const location = useLocation();
  const themeColor = routeThemeColors[location.pathname] || "rgba(25, 34, 74, 1)";


  ScrollToTop();

  useEffect(() => {
    // Defer loading to after first render
    const timeout = setTimeout(() => {
      setShowCookieConsent(true);
    }, 2500); // 2-second delay (adjust based on LCP goals)

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 20;
      setIsPageScrolled(scrolled);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // check on mount

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  return (
    <HelmetProvider>
      <Helmet>
        <meta name="theme-color" content={themeColor} />
      </Helmet>
      <LoaderComponent loading={loading}>
        <Container id="scroller" ref={scrollRef}>
          <Header
            setIsBackgropVisible={setIsBackgropVisible}
            isPageScrolled={isPageScrolled}
          />
          {isBackgropVisible && <Backdrop />}
          <Outlet
            context={{
              loading,
              setLoading,
              setIsPageScrolled,
            }}
          />
          <SitemMap />
          <Footer />
        </Container>
      </LoaderComponent>
      {showCookieConsent && (
        <Suspense fallback={null}>
          <LazyCookieConsent />
        </Suspense>
      )}
    </HelmetProvider>
  );
}

export default App;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
`;

const Backdrop = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 2;
`;
